var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:[_vm.blockClassName, `${_vm.icon} ${_vm.modifiers}`],style:({color: _vm.color}),on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }